import { Card, Table } from "react-bootstrap";
import EventChatPostCreate from "./EventChatPostCreate";
import EventChatDisplayPostsRow from "./EventChatDisplayPostsRow";
import { useForumPosts } from "../util/db";

function EventManageChat({ eventId, uid }) {
  const {
    data: posts,
    // status: postsStatus,
    // error: postsError,
  } = useForumPosts(eventId);

  return (
    <>
      {/* Post Creation Card */}
      <div className="mb-4">
        <EventChatPostCreate eventId={eventId} uid={uid} />
      </div>

      {/* Recent Messages Table Card */}
      <Card
        style={{ borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
        className="mb-3"
      >
        <Card.Header
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            Recent Messages
          </Card.Title>
        </Card.Header>
        <Card.Body
          style={{
            background: "#FFFFFF",
            padding: "0",
            borderRadius: "0 0 12px 12px",
            overflow: "hidden",
          }}
        >
          {posts && posts.length > 0 ? (
            <Table
              responsive
              className="table table-striped mb-0"
              style={{ border: "none" }}
            >
              <thead style={{ background: "#f8f9fa" }}>
                <tr>
                  <th
                    className="text-center"
                    style={{ color: "#495057", width: "15%" }}
                  >
                    User
                  </th>
                  <th
                    className="text-center"
                    style={{ color: "#495057", width: "20%" }}
                  >
                    Date/Time
                  </th>
                  <th
                    className="text-start"
                    style={{ color: "#495057", textAlign: "left" }}
                  >
                    Message
                  </th>
                  <th
                    className="text-center"
                    style={{ color: "#495057", width: "10%" }}
                  >
                    Hide
                  </th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post, index) => (
                  <EventChatDisplayPostsRow key={index} post={post} />
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4">
              No messages yet. Be the first to post!
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default EventManageChat;
